import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

const CalendarDayView = ({
  calendarData,
  selectedDate,
  getShipmentBackgroundColor,
  getShipmentStatusText,
  getTransportIcon,
  handleShipmentClick,
  isShipmentCritical,
  isShipmentDelayed,
  isShipmentUpcoming,
  getEtaDate,
}) => {
  // Get the day's data from calendar data
  const dayData = calendarData.length > 0 ? calendarData[0] : { shipments: [] };

  // Format date for display
  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return new Date(date).toLocaleDateString();
    } catch (error) {
      console.error("Error formatting date:", error);
      return "N/A";
    }
  };

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden p-4">
      <h3 className="text-lg font-medium mb-4">
        Shipments for{" "}
        {selectedDate.toLocaleDateString([], {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric",
        })}
      </h3>

      {dayData.shipments.length > 0 ? (
        <div className="space-y-3">
          {dayData.shipments.map((shipment) => (
            <div
              key={shipment.header.reference}
              className={`p-3 rounded-lg border-l-4 ${
                isShipmentCritical(shipment)
                  ? "border-l-red-500"
                  : isShipmentDelayed(shipment)
                  ? "border-l-amber-500"
                  : isShipmentUpcoming(shipment)
                  ? "border-l-blue-500"
                  : "border-l-green-500"
              } ${getShipmentBackgroundColor(
                shipment
              )} hover:shadow-md transition-shadow`}
            >
              <div className="flex justify-between">
                <div>
                  <div className="flex items-center space-x-2">
                    <span className="font-medium text-lg">
                      {shipment.header.reference}
                    </span>
                    <FontAwesomeIcon
                      icon={
                        getTransportIcon(
                          shipment.header.pedimento?.pedimento_entry_point
                        ).icon
                      }
                      className={`${
                        getTransportIcon(
                          shipment.header.pedimento?.pedimento_entry_point
                        ).color
                      } text-lg`}
                      title={
                        getTransportIcon(
                          shipment.header.pedimento?.pedimento_entry_point
                        ).title
                      }
                    />
                    <span className="text-sm bg-gray-200 rounded px-2 py-0.5">
                      {getShipmentStatusText(shipment)}
                    </span>
                  </div>
                  <div className="mt-1 text-gray-600">
                    {shipment.header.customer_name} (
                    {shipment.header.customer_id})
                  </div>
                </div>

                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm flex items-center space-x-1 transition-colors"
                  onClick={() => handleShipmentClick(shipment)}
                >
                  <FontAwesomeIcon icon={faEye} />
                  <span>Details</span>
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                <div>
                  <h4 className="text-xs text-gray-500 uppercase">
                    Bill of Lading
                  </h4>
                  <p className="font-medium">
                    {(shipment.header.bill_of_lading_data &&
                      shipment.header.bill_of_lading_data[0]?.bill_of_lading) ||
                      "N/A"}
                  </p>
                </div>

                <div>
                  <h4 className="text-xs text-gray-500 uppercase">Pedimento</h4>
                  <p className="font-medium">
                    {shipment.header.pedimento?.pedimento_number || "N/A"}
                  </p>
                </div>

                <div>
                  <h4 className="text-xs text-gray-500 uppercase">ETA Date</h4>
                  <p className="font-medium">
                    {getEtaDate(shipment)
                      ? formatDate(getEtaDate(shipment))
                      : "N/A"}
                  </p>
                </div>

                <div>
                  <h4 className="text-xs text-gray-500 uppercase">
                    Operation Type
                  </h4>
                  <p className="font-medium">
                    {shipment.header.operation_type === "1"
                      ? "Import"
                      : shipment.header.operation_type === "2"
                      ? "Export"
                      : shipment.header.operation_type}
                  </p>
                </div>

                <div>
                  <h4 className="text-xs text-gray-500 uppercase">Status</h4>
                  <p className="font-medium">
                    {shipment.header.trafficStatus || "N/A"}
                  </p>
                </div>

                <div>
                  <h4 className="text-xs text-gray-500 uppercase">Weight</h4>
                  <p className="font-medium">
                    {shipment.header.weight
                      ? `${shipment.header.weight} kg`
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500 bg-gray-50 rounded-lg">
          No shipments scheduled for this day
        </div>
      )}
    </div>
  );
};

export default CalendarDayView;
